import React from 'react';
import { Clapperboard } from 'lucide-react';
import { useLocale } from '../../contexts/LocaleContext';
import { cn } from '@/lib/utils';

export type ScriptInfoStatsLabels = {
  scenes?: string;
  dialogWords: string;
  dialogEstimation: string;
};

export function ScriptInfoStats({
  labels,
  className,
}: {
  labels: ScriptInfoStatsLabels;
  className?: string;
}): React.ReactElement {
  const { t } = useLocale();

  return (
    <div className={cn('text-xs leading-5 text-muted-foreground', className)}>
      <div className="mb-1.5 flex items-center gap-1.5 font-medium text-foreground">
        <Clapperboard className="h-3.5 w-3.5 shrink-0" aria-hidden />
        <span>{t('script_info')}</span>
      </div>
      {labels.scenes ? <div className="tabular-nums">{labels.scenes}</div> : null}
      <div className="tabular-nums">{labels.dialogWords}</div>
      <div className="tabular-nums">{labels.dialogEstimation}</div>
    </div>
  );
}
